// import { useEffect } from 'react'
import Layout from '@/component/Layout/Layout'
import useHome from './hooks/useHome'
import useResultSlider from './hooks/useResultSlider'
import { useNavigate } from 'react-router'
// import { useLoading } from '@/ui-components/context/LoadingProvider'
import { HomeScreen } from '@/ui-components/screens/HomeScreen'

const Home = () => {
  const navigate = useNavigate()
  const {
    messages,
    TABS,
    selectedTabs,
    toggleTab,
    groupsLotto,
    loading,
    clearAll,
  } = useHome()

  const results = useResultSlider()

  const onClickResult = () => {
    navigate('/lotto/result')
  }

  // For testing error boundary
  if (localStorage.getItem('test-error-from-react')) {
    throw new Error('test-error-from-react')
  }

  return (
    <Layout loading={loading}>
      <HomeScreen
        notificationBannerProps={{ messages }}
        swiperResultProps={{ components: results, onCardClick: onClickResult }}
        selectionTabsProps={{
          tabs: TABS,
          selectedTabs,
          onSelectTab: toggleTab,
          onClear: clearAll,
        }}
        groupsLotto={groupsLotto}
      />
    </Layout>
  )
}

export default Home
